import { IsEnglish } from '@utils/language';
import i18next from 'i18next';

export function GetWorksiteDescription(company, worksite, worksites) {
    const objWorksite = worksites.find(x => x.worksite == worksite && x.company == company);

    return IsEnglish() ?
        `${company} - ${objWorksite.companyDescriptionEnglish} / ${i18next.t('accessType:supervisor.mini-description-worksite')} ${objWorksite.worksite}` :
        `${company} - ${objWorksite.companyDescriptionFrench} / ${i18next.t('accessType:supervisor.mini-description-worksite')} ${objWorksite.worksite}`;
}